import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { mq } from '@unowmooc/themes'
import { withUser } from 'store/UserProvider'
import Helmet from 'components/HelmetIntl'
import Form from './Form'

const StyledForm = styled(Form)`
  ${mq.sm(css`
    margin-top: 26px;
  `)};
`

const ProfilePage = ({ user }) => (
  <>
    <Helmet title="page_titles.settings.profile.title" />
    <StyledForm id={user.id} title={<FormattedMessage id="settings.profile.page_title" />} />
  </>
)

ProfilePage.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.shape.isRequired,
  }).isRequired,
}

export default withUser(ProfilePage)
